const initState = {
    app_unique_key: '',
    aside_right_open: false,
    aside_collapse: false,
    route_has_changed: false,
};

const GlobalReducer = (state = initState, action) => {
    switch (action.type) {
        case "APP_UNIQUE_KEY" : {
            return Object.assign({}, state, {
                app_unique_key: action.app_unique_key,
            });
        }
        case "ASIDE_RIGHT_OPEN" : {
            return Object.assign({}, state, {
                aside_right_open: action.aside_right_open,
            });
        }; break;

        case "ASIDE_COLLAPSE" : {
            return Object.assign({}, state, {
                aside_collapse: action.aside_collapse,
            });
        }; break;

        case "ROUTE_HAS_CHANGED": {
            return Object.assign({}, state, {
                route_has_changed: action.route_has_changed,
            });
        }; break;

        default: {
            return state;
        }; break;
    }
}

export default GlobalReducer;